<template src="./index.html"></template>

<script>
import * as echarts from 'echarts';
import { getdata } from './data';
import {
    sy_comapny,
    sy_statistics_gswdswqkb,
    sy_statistics_gswdzsjzqkb,
    sy_statistics_head_data,
    sy_statistics_price_head,
    sy_statistics_sfqk,
    sy_statistics_ssdyhcpcqkb,
    sy_statistics_szwdsezbqkb,
    sy_statistics_xmwdzsjzqkb
} from '../../../api/homepagenew.js';
import LargeChart from './LargeChart/index.vue';

export default {
    components: {
        LargeChart
    },
	data() {
		return {
            pickerOptions: {
                shortcuts: [{
                    text: '本月',
                    onClick(picker) {
                        picker.$emit('pick', [new Date(), new Date()]);
                    }
                }, {
                    text: '今年至今',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date(new Date().getFullYear(), 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近六个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setMonth(start.getMonth() - 6);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            headStatisticData: getdata().headStatisticData,
            pageHeadData: getdata().pageHeadData,
            taxBl: false,
            priceBl: false,
            sfbl: false,
            wdseType: '',
            sfqkType: '',
            dateRange: '',
            gswdseqkb: {},
            gswdzsjzqkb: {},
            sfqk: {},
            xmwdzsjzqkb: {},
            largeType: '',
            largeChartData: null,
            companys: [],
            btdata: [
                { value: 0, key:1, name: '增值税', itemStyle: { color: '#497DF2' } },
                { value: 0, key:3, name: '企业所得税', itemStyle: { color: '#ABDFEE' } },
                { value: 0, key:9,  name: '印花税', itemStyle: { color: '#8BD4C3' } },
                { value: 0, key:13,  name: '房产税', itemStyle: { color: '#3CCEF2' } },
                { value: 0, key:10,  name: '城镇土地使用税', itemStyle: { color: '#97B2F3' } },
            ],
            companyDimension: [
                {
                    label: '增值税',
                    value: 1,
                },
                {
                    label: '企业所得税',
                    value: 3,
                },
                {
                    label: '印花税',
                    value: 9,
                },
                {
                    label: '房产税',
                    value: 13,
                },
                {
                    label: '城镇土地使用税',
                    value: 10,
                }
            ],
            shuifList: [
                {
                    label: '总税负',
                    value: 0,
                },
                {
                    label: '增值税',
                    value: 1,
                },
                {
                    label: '企业所得税',
                    value: 3,
                }
            ],
            projectModel: {
                "zzs_2_22_1": "期末留抵税额退税",
                "zzs_2_7_3": "增值税-境外劳务抵扣进项税",
                "sdsA_1_13.1_2": "企业所得税-高新技术企业税收优惠",
                "sdsA_1_7_1": "企业所得税-研发费用加计扣除",
                "zzs_4_8_5": "增值税加计抵减",
                "sdsA_1_13.2_2": "小微企业所得优惠"
            },
            companyNo: '',
            wdseChart: null,
            wdtsChart: null,
            sezbChart: null,
            sfqkChart: null,
            xmzsChart: null,
            headData:getdata().headData,
            tableData: [],
            tablekey: 0,
            companyDialog: false,
        };
	},
	created() {
	},
	mounted() {
        this.dateRange = [this.$getdefultMonth(), this.$getdefultMonth()];
        this.queryCompanyCode();
        this.statistics();
        window.addEventListener('resize', this.handleResize);
	},
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        if (this.wdseChart) {
            this.wdseChart.dispose()// 销毁实例
        }
        if (this.wdtsChart) {
            this.wdtsChart.dispose()// 销毁实例
        }
        if (this.sezbChart) {
            this.sezbChart.dispose()// 销毁实例
        }
        if (this.sfqkChart) {
            this.sfqkChart.dispose()// 销毁实例
        }
        if (this.xmzsChart) {
            this.xmzsChart.dispose()// 销毁实例
        }
    },
	methods: {
        companyTaxClose() {
            this.companyDialog = false;
        },
        queryCompanyCode(){
            sy_comapny().then(res => {
                if (res.data.code === 1) {
                    res.data.data.forEach(item => {
                        this.companys.push({
                            value: item.companyNo,
                            label: item.nsrmc
                        })
                    })
                }
            })
        },
        allViewClick(type, chartData) {
            this.companyDialog = true;
            this.largeType = type;
            this.largeChartData = chartData;
        },
        change() {
            this.statistics();
        },
        statistics() {
            /*let dates = String(this.dateRange);
            sy_statistics({
                shenbq: this.$getdefultMonth(),
                companyNo: this.companyNo,
                startDate: dates.split(",")[0],
                endDate: dates.split(",")[1],
                dimensionType: this.wdseType,
                type: this.sfqkType
            }).then(res => {
                if (res.data.code === "1") {
                    this.headStatisticData = res.data.data;
                    this.tableData = res.data.data.taxResearchRate;
                    this.taxBl = String(this.headStatisticData.taxAmountScale).indexOf("-") < 0;
                    this.priceBl = String(this.headStatisticData.preferentialPoliciesScale).indexOf("-") < 0;
                    this.sfbl = String(this.headStatisticData.taxBurdenScale).indexOf("-") < 0;
                }
                this.initChart();
            })*/
            this.statisticsHeadData();
            this.statisticsPriceHead();
            this.statisticsGSWDSWQKB();
            this.statisticsGSWDZSJZQKB();
            this.statisticsSZWDSEZBQKB();
            this.statisticsSFQK();
            this.statisticsXMWDZSJZQKB();
            this.statisticsSSDYHCPCQKB();
        },
        statisticsHeadData() {
            sy_statistics_head_data({
                shenbq: this.$getdefultMonth(),
                companyNo: this.companyNo,
            }).then(res => {
                if (res.data.code === "1") {
                    this.pageHeadData = res.data.data;
                }
            })
        },
        statisticsPriceHead() {
            let dates = String(this.dateRange);
            sy_statistics_price_head({
                companyNo: this.companyNo,
                startDate: dates.split(",")[0],
                endDate: dates.split(",")[1],
            }).then(res => {
                if (res.data.code === "1") {
                    this.headStatisticData = res.data.data;
                    this.taxBl = String(this.headStatisticData.taxAmountScale).indexOf("-") < 0;
                    this.priceBl = String(this.headStatisticData.preferentialPoliciesScale).indexOf("-") < 0;
                    this.sfbl = String(this.headStatisticData.taxBurdenScale).indexOf("-") < 0;
                }
            });
        },
        statisticsGSWDSWQKB() {
            let dates = String(this.dateRange);
            sy_statistics_gswdswqkb({
                companyNo: this.companyNo,
                startDate: dates.split(",")[0],
                endDate: dates.split(",")[1],
                dimensionType: this.wdseType,
            }).then(res => {
                if (res.data.code === "1") {
                    this.gswdseqkb = res.data.data.dimensionTax
                    this.initWdse(this.gswdseqkb);
                }
            })
        },
        statisticsGSWDZSJZQKB() {
            let dates = String(this.dateRange);
            sy_statistics_gswdzsjzqkb({
                companyNo: this.companyNo,
                startDate: dates.split(",")[0],
                endDate: dates.split(",")[1]
            }).then(res => {
                if (res.data.code === "1") {
                    this.gswdzsjzqkb = res.data.data.dimensionIncreases
                    this.initWdts(this.gswdzsjzqkb);
                }
            })
        },
        statisticsSZWDSEZBQKB() {
            let dates = String(this.dateRange);
            sy_statistics_szwdsezbqkb({
                companyNo: this.companyNo,
                startDate: dates.split(",")[0],
                endDate: dates.split(",")[1]
            }).then(res => {
                if (res.data.code === "1") {
                    this.initSezb(res.data.data.taxTypeProportion);
                }
            })
        },
        statisticsSFQK() {
            let dates = String(this.dateRange);
            sy_statistics_sfqk({
                companyNo: this.companyNo,
                startDate: dates.split(",")[0],
                endDate: dates.split(",")[1],
                type: this.sfqkType
            }).then(res => {
                if (res.data.code === "1") {
                    this.sfqk = res.data.data.taxBurdenSituation;
                    this.initSfqk(this.sfqk);
                }
            })
        },
        statisticsXMWDZSJZQKB() {
            let dates = String(this.dateRange);
            sy_statistics_xmwdzsjzqkb({
                companyNo: this.companyNo,
                startDate: dates.split(",")[0],
                endDate: dates.split(",")[1]
            }).then(res => {
                this.xmwdzsjzqkb = res.data.data.projectDimensionIncreases;
                this.initXmzs(this.xmwdzsjzqkb);
            })
        },
        statisticsSSDYHCPCQKB() {
            sy_statistics_ssdyhcpcqkb({
                companyNo: this.companyNo
            }).then(res => {
                this.tableData = res.data.data.taxResearchRate;
            })
        },
        dateChange() {
            this.statistics();
        },
        test(res){
            console.log(res);
            return false;
        },
        /*initChart() {
            this.initWdse();
            this.initWdts();
            this.initSezb();
            this.initSfqk();
            this.initXmzs();
        },*/
        initXmzs(data) {
            let xdata = [];
            let ydata = [];
            //let data = this.headStatisticData.projectDimensionIncreases;
            if (data) {
                for (const key in data) {
                    if (data.hasOwnProperty(key)) {  // 避免遍历原型链上的属性
                        const value = data[key];
                        xdata.push(value);
                        ydata.push(this.projectModel[key]);
                    }
                }
            }
            let chartDom = document.getElementById('xmzsContainer');
            this.xmzsChart = echarts.init(chartDom);
            let option;

            option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01],
                    axisLine: {
                        show: false // 隐藏 x 轴基线（最下面的横线）
                    },
                    axisTick: {
                        show: false // 隐藏 x 轴刻度线
                    },
                    axisLabel: {
                        color: '#999999' // x轴刻度文字颜色
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed', // 横向网格线改为虚线
                            color: '#E5E5E5' // 虚线颜色
                        }
                    },
                    name: '（万元）',// 标题文本
                    nameTextStyle: {
                        color: '#999999', // 颜色与刻度一致
                        fontSize: 12,
                        padding: [0, 0, 0, -40]
                    },
                },
                yAxis: {
                    type: 'category',
                    data: ydata,
                    axisLine: {
                        show: false // 隐藏 y 轴基线
                    },
                    axisLabel: {
                        color: '#999999' // x轴刻度文字颜色
                    },
                    axisTick: {
                        show: false // 隐藏 y 轴刻度线
                    },
                    name: '（政策）',// 标题文本
                    nameTextStyle: {
                        color: '#999999', // 颜色与刻度一致
                        fontSize: 12,
                        padding: [0, 0, -10, -40]
                    },
                },
                series: [
                    {
                        name: '',
                        type: 'bar',
                        barWidth: '45%', // 调整柱子宽度（原默认约60%）
                        data: xdata,
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 1, 0, // 渐变方向（从左到右）
                                [

                                    { offset: 0, color: '#0065B1' },  // 结束颜色（蓝色）
                                    { offset: 1, color: '#7BC0F5' } // 起始颜色（白色）
                                ]
                            ),
                            borderRadius: [0, 20, 20, 0] // 顶部圆角（右侧两个角）
                        }
                    }
                ]
            };

            option && this.xmzsChart.setOption(option);
        },
        initSfqk(dimensionTax) {
            let xdata = [];
            let ydata = [];
            //let dimensionTax = this.headStatisticData.taxBurdenSituation;
            if (dimensionTax) {
                for (const key in dimensionTax) {
                    if (dimensionTax.hasOwnProperty(key)) {  // 避免遍历原型链上的属性
                        const value = dimensionTax[key];
                        xdata.push(key);
                        ydata.push(value);
                    }
                }
            }
            let chartDom = document.getElementById('sfqkContainer');
            this.sfqkChart = echarts.init(chartDom);
            let option;

            option = {
                tooltip: { // 新增悬浮提示配置
                    trigger: 'axis', // 触发方式（坐标轴触发）
                    axisPointer: {
                        type: 'shadow' // 指示器类型（可选：'line'|'shadow'|'none'）
                    },
                    formatter: '{b}<br/>税负情况: {c}' // 自定义提示内容格式
                    // 默认格式也可直接使用，无需formatter
                },
                xAxis: {
                    type: 'category',
                    data: xdata,
                    axisLabel: {
                        color: '#999999' // x轴刻度文字颜色
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#6E7079' // x轴线颜色
                        }
                    },
                    name: '（公司）',// 标题文本
                    nameTextStyle: {
                        color: '#999999', // 颜色与刻度一致
                        fontSize: 12,
                        padding: [20, 0, 0, -20]
                    },
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        lineStyle: {
                            type: 'dashed', // 全局设置为虚线
                            color: '#E5E5E5' // 虚线颜色（可选）
                        },
                        // 特殊处理最底部实线
                        show: (params) => params.value !== 0 // 假设0是最底部刻度
                    },
                    axisLine: {
                        show: false // 隐藏y轴竖线
                    },
                    axisLabel: {
                        color: '#999999' // y轴刻度文字颜色
                    },
                    name: '比例：%',// 标题文本
                    nameTextStyle: {
                        color: '#999999', // 颜色与刻度一致
                        fontSize: 12,
                        padding: [20, 0, 0, -20]
                    },
                },
                series: [
                    {
                        data: ydata,
                        type: 'line',
                        itemStyle: {
                            color: '#0065B1' // 数据点颜色（更新为#0065B1）
                        },
                        lineStyle: {
                            color: '#0065B1' // 线条颜色（更新为#0065B1）
                        }
                    }
                ]
            };

            option && this.sfqkChart.setOption(option);
        },
        initSezb(data) {
            if (data) {
                for (const key in data) {
                    if (data.hasOwnProperty(key)) {  // 避免遍历原型链上的属性
                        this.btdata.find(item => item.key === Number(key))["value"] = data[key];
                    }
                }
            }
            let chartDom = document.getElementById('sezbContainer');
            this.sezbChart = echarts.init(chartDom);
            let option;

            option = {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    left: '75%',  // 关键修改：图例距离左侧75%（靠右显示）
                    top: 'center',
                    itemGap: 15,
                    textStyle: {
                        color: '#333'
                    }
                },
                series: [
                    {
                        name: '税额占比',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        center: ['35%', '50%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,  // 这里导致悬浮时显示文字
                                fontSize: 15,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: this.btdata
                    }
                ]
            };

            option && this.sezbChart.setOption(option);

        },
        initWdse(dimensionTax) {
            let xdata = [];
            let ydata = [];
            //let dimensionTax = this.headStatisticData.dimensionTax;
            if (dimensionTax) {
                for (const key in dimensionTax) {
                    if (dimensionTax.hasOwnProperty(key)) {  // 避免遍历原型链上的属性
                        const value = dimensionTax[key];
                        xdata.push(key);
                        ydata.push(value);
                    }
                }
            }
            let chartDom = document.getElementById('wdseContainer');
            this.wdseChart = echarts.init(chartDom);
            let option;

            option = {
                xAxis: {
                    type: 'category',
                    data: xdata,
                    // 关键设置：横向刻度标签颜色
                    axisLabel: {
                        color: '#999999' // 统一为灰色
                    },
                    name: '（公司）',// 标题文本
                    nameTextStyle: {
                        color: '#999999', // 颜色与刻度一致
                        fontSize: 12,
                        padding: [20, 0, 0, -20]
                    },
                },
                yAxis: {
                    type: 'value',
                    // 隐藏左侧竖线（Y轴轴线）
                    axisLine: {
                        show: false // 关键配置
                    },
                    // 修改刻度标签颜色
                    axisLabel: {
                        color: '#999999' // 刻度值颜色
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed', // 全局设置为虚线
                            color: '#E5E5E5' // 虚线颜色（可选）
                        },
                        // 特殊处理最底部实线
                        show: (params) => params.value !== 0 // 假设0是最底部刻度
                    },
                    name: '缴款金额：万元', // 标题文本
                    nameTextStyle: {
                        color: '#999999', // 颜色与刻度一致
                        fontSize: 12,
                        padding: [0, -20, 0, 0]
                    },
                },
                series: [{
                    data: ydata,
                    type: 'bar',
                    barWidth: '50%',
                    itemStyle: {
                        color: '#5B96FF' // 直接指定颜色
                    }
                }]
            };
            option && this.wdseChart.setOption(option);
        },
        initWdts(data) {
            let chartDom = document.getElementById('wdtsContainer');
            this.wdtsChart = echarts.init(chartDom);
            let option;
            let xdata = [];
            let ydata = [];
            //let data = this.headStatisticData.dimensionIncreases;
            if (data) {
                for (const key in data) {
                    if (data.hasOwnProperty(key)) {  // 避免遍历原型链上的属性
                        const value = data[key];
                        xdata.push(key);
                        ydata.push(value);
                    }
                }
            }
            option = {
                xAxis: {
                    type: 'category',
                    data: xdata,
                    // 关键设置：横向刻度标签颜色
                    axisLabel: {
                        color: '#999999' // 统一为灰色
                    },
                    name: '（公司）',// 标题文本
                    nameTextStyle: {
                        color: '#999999', // 颜色与刻度一致
                        fontSize: 12,
                        padding: [20, 0, 0, -20]
                    },
                },
                yAxis: {
                    type: 'value',
                    // 隐藏左侧竖线（Y轴轴线）
                    axisLine: {
                        show: false // 关键配置
                    },
                    // 修改刻度标签颜色
                    axisLabel: {
                        color: '#999999' // 刻度值颜色
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed', // 全局设置为虚线
                            color: '#E5E5E5' // 虚线颜色（可选）
                        },
                        // 特殊处理最底部实线
                        show: (params) => params.value !== 0 // 假设0是最底部刻度
                    },
                    name: '金额：万元', // 标题文本
                    nameTextStyle: {
                        color: '#999999', // 颜色与刻度一致
                        fontSize: 12,
                        padding: [0, 0, 0, 0]
                    },
                },
                series: [{
                    data: ydata,
                    type: 'bar',
                    barWidth: '50%',
                    itemStyle: {
                        color: '#0065B1' // 直接指定颜色
                    }
                }]
            };
            option && this.wdtsChart.setOption(option);
        },
        handleResize() {
            if (this.wdseChart) {
                this.wdseChart.resize(); // 关键：重新计算尺寸
            }
            if (this.wdtsChart) {
                this.wdtsChart.resize(); // 关键：重新计算尺寸
            }
            if (this.sezbChart) {
                this.sezbChart.resize(); // 关键：重新计算尺寸
            }
            if (this.sfqkChart) {
                this.sfqkChart.resize(); // 关键：重新计算尺寸
            }
            if (this.xmzsChart) {
                this.xmzsChart.resize(); // 关键：重新计算尺寸
            }
        }
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
